import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import Stack from '@mui/material/Stack';
import {sx} from './sx'
import Typography from '@mui/material/Typography';
import {IConfigTaskTemplateSingleVoyage} from "@containers/singleVoyage/taskTemplate/types";

interface IProps {
    tasks: {
        config?: IConfigTaskTemplateSingleVoyage
    }[]
}

const PointTasksMiniInfoMutateSingleVoyage = ({tasks}: IProps) => {

    const {t} = useTranslation()

    // photoRequired arrives as the string 'YES'/'NO' - both are truthy in JS,
    // so compare explicitly.
    const hasPhotoReport = useMemo(() => {
        return tasks.some((item) => item?.config?.photoRequired === 'YES')
    }, [tasks])

    return (
        <Stack
            gap={'4px'}
            direction={'row'}
            alignItems={'center'}
            flexWrap={'wrap'}
            justifyContent={'flex-start'}
        >
            <Typography sx={sx.item}>
                {t('singleVoyage.tasks')}
            </Typography>

            {hasPhotoReport && <Typography sx={sx.item}>
                {t('singleVoyage.photoReport')}
            </Typography>}
        </Stack>
    );
};

export default PointTasksMiniInfoMutateSingleVoyage;
